module.exports = __webpack_public_path__ + "static/img/logo_fusesecurity.1be54e7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo_fusesecurity.svg
// module id = WeCx
// module chunks = 1